import React from 'react'
import styled from 'styled-components'
import ColSpacer from "../../common/styles/ColSpacer";
import {useNavigate} from "react-router-dom";
import IndexContentContainer from "../index/IndexContentContainer";
import BookIsbnResponse from "./isbn/BookIsbnResponse";
import {Author} from "../../common/Author";
import {BookStatus} from "./BookType";
import BooksitoutImages from "../../images/BooksitoutImages";

interface Props {
	book: BookIsbnResponse
}

const BookIsbnListRow: React.FC<Props> = ({ book }) => {
	const navigate = useNavigate()

	return (
		<IndexContentContainer href={`/book/${book.isbn13}?q=${book.title}`} backgroundColorType={'card-card'}>
			<div className={'w-100'}>
				<ClickableOverlay
					clickable={!!book.bookId}
					onClick={e => {
						e.preventDefault()
						book.bookId && navigate(`/book/mine/${book.bookId}`)
					}}
				/>
				<GlowCard status={book.status} />
				<Row>
					<CoverContainer>
						<Cover src={book.coverUrl ?? BooksitoutImages.Placeholder.bookCover} />
					</CoverContainer>

					<ColSpacer size={5} />

					<InfoContainer>
						<Title>{book.title}</Title>
						<Author size={16}>{book.authors}</Author>
					</InfoContainer>
				</Row>
			</div>
		</IndexContentContainer>
	)
}

const Row = styled.div`
	position: relative;
	display: flex;
	width: 100%;
`

const GlowCard = styled.div<{ status: BookStatus }>`
	position: absolute;
	top: 0;
	right: 0;
	width: 8px;
	height: 100%;
	background: linear-gradient(90deg, ${props => (props.status == 'NOT_ADDED' ? 'none' : props.status == 'GIVE_UP' ? '#ef4444' : '#22c55e')} 0%, ${props => (props.status == 'NOT_ADDED' ? '#9ca3af' : props.status == 'GIVE_UP' ? '#ef4444' : '#22c55e')} 70%, transparent 100%);
	z-index: 1;
`

const ClickableOverlay = styled.div<{ clickable: boolean }>`
	position: absolute;
	top: 0;
	right: 0;
	width: 10%;
	height: 100%;
	z-index: 10;
	cursor: ${props => (props.clickable ? 'pointer' : 'default')};
`

const CoverContainer = styled.div`
	min-width: 75px;
	max-width: 75px;
	justify-content: center;
	text-align: center;
`

interface CoverProps {
	src: string | null
}

const Cover = styled.img.attrs({
	className: 'img-fluid rounded',
})<CoverProps>`
	height: 90px;
`

const Title = styled.h5.attrs({
	className: 'clamp-1-line',
})``

const InfoContainer = styled.div`
	display: flex;
	flex-direction: column;

	max-width: calc(100% - 100px);
`

export default BookIsbnListRow
